export default __webpack_public_path__ + "static/media/organicwinecork.f487034c.jpg";